module.exports = __webpack_public_path__ + "media/styles/images/svg/slash-gray-8b857e7deb1ed7bcb8710c625e17d806.svg";